import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';

type ExpandIconProps = Omit<BaseIconProps, 'children' | 'hasLegacyStrokeStyles'>;

export const ExpandIcon = ({ strokeWidth, ...props }: ExpandIconProps) => (
  <BaseIcon
    hasLegacyStrokeStyles={false}
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    strokeWidth={strokeWidth}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 4H8.5V2H2.42308C1.36125 2 0.5 2.86125 0.5 3.92308V14.0769C0.5 15.1387 1.36125 16 2.42308 16H12.5769C13.6387 16 14.5 15.1387 14.5 14.0769L14.5 8H12.5L12.5 14H2.5V4Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.2071 0.292893C16.5976 0.683417 16.5976 1.31658 16.2071 1.70711L9.20711 8.70711C8.81658 9.09763 8.18342 9.09763 7.79289 8.70711C7.40237 8.31658 7.40237 7.68342 7.79289 7.29289L14.7929 0.292893C15.1834 -0.0976311 15.8166 -0.0976311 16.2071 0.292893Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 1C10.5 0.447715 10.9477 0 11.5 0H15.5C16.0523 0 16.5 0.447715 16.5 1V5C16.5 5.55228 16.0523 6 15.5 6C14.9477 6 14.5 5.55228 14.5 5V2H11.5C10.9477 2 10.5 1.55228 10.5 1Z"
    />
  </BaseIcon>
);

ExpandIcon.displayName = 'ExpandIcon';
